module.exports = __webpack_public_path__ + "img/pic24.ab027621.png";